<template>
  <div
    :class="[
      (cloudTenantLeaders.flagged_tenants.includes(entity.id) &&
        entity.type === 2) ||
      entity.type === 1 ||
      entity.type === 3
        ? 'space-x-4'
        : 'space-x-2',
      context === 'posts' ? 'w-3/4 cursor-pointer' : 'w-full',
    ]"
    class="flex items-center group"
  >
    <div
      :class="[
        cloudTenantLeaders.flagged_tenants.includes(entity.id)
          ? 'contributor-badge-cw'
          : '',
        (entity.type === 3 && context === 'posts') || entity.type === 1
          ? 'contributor-badge'
          : 'border-truegray-100',
        context === 'posts' ? 'border-2' : '',
      ]"
      class="rounded-full flex items-center justify-center w-12 h-12 relative flex-shrink-0"
    >
      <div
        v-if="entity.logo"
        class="bg-no-repeat bg-cover bg-center rounded-full"
        :class="context === 'posts' ? 'w-8 h-8' : 'w-12 h-12'"
        :style="{ backgroundImage: 'url(' + entity.logo + ')' }"
        @click="showProfile(entity)"
      ></div>
      <div
        v-else
        class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
        @click="showProfile(entity)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
            clip-rule="evenodd"
          />
        </svg>
      </div>

      <!-- Author types : 0 === expo nonpro, 1 === expo pro, 2 === cw tenant, 3 === cw contributor  -->
      <div
        v-if="entity && (entity.type === 3 || entity.type === 1)"
        :style="[{ top: '-0.4rem' }, { left: '1.8rem' }]"
        class="absolute border-2 border-white contributor-badge-circle h-5 w-5 p-1 rounded-full text-white"
      >
        <div class="relative group">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-2 w-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
          <div
            :style="{ width: 'max-content' }"
            class="absolute opacity-0 pointer-events-none group-hover:opacity-100 left-8 top-0 bg-white rounded px-4 py-2 border border-truegray-300 text-black font-primary text-center"
          >
            Verified Contributor
          </div>
        </div>
      </div>

      <!-- check mark for tenant leader badge -->
      <div
        v-if="
          cloudTenantLeaders.flagged_tenants.includes(entity.id) &&
          entity.type === 2
        "
        :style="[{ top: '-0.7rem' }, { left: '1.5rem' }]"
        class="absolute h-8 w-8 p-1 rounded-full text-white"
        @click="showProfile(entity)"
      >
        <img
          src="/img/cloud_badges/badge_leader.png"
          alt="CareerWise tenant category leader badge"
        />
      </div>

      <!-- Tenant leader badge container -->
      <div
        v-if="
          cloudTenantLeaders.flagged_tenants.includes(entity.id) &&
          entity.type === 2
        "
        :style="{ top: '0.8rem' }"
        class="w-full h-full absolute left-0 flex items-end justify-center"
        @click="showProfile(entity)"
      >
        <img
          v-if="cloudTenantLeaders.share_avg[0] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_avg_gold.png"
          alt="CareerWise tenant category leader badge"
        />
        <img
          v-if="cloudTenantLeaders.share_avg[1] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_avg_silver.png"
          alt="CareerWise tenant category leader badge"
        />
        <img
          v-if="cloudTenantLeaders.share_avg[2] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_avg_bronze.png"
          alt="CareerWise tenant category leader badge"
        />

        <img
          v-if="cloudTenantLeaders.posts[0] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_posts_gold.png"
          alt="CareerWise tenant category leader badge"
        />
        <img
          v-if="cloudTenantLeaders.posts[1] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_posts_silver.png"
          alt="CareerWise tenant category leader badge"
        />
        <img
          v-if="cloudTenantLeaders.posts[2] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_posts_bronze.png"
          alt="CareerWise tenant category leader badge"
        />

        <img
          v-if="cloudTenantLeaders.shares[0] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_shares_gold.png"
          alt="CareerWise tenant category leader badge"
        />
        <img
          v-if="cloudTenantLeaders.shares[1] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_shares_silver.png"
          alt="CareerWise tenant category leader badge"
        />
        <img
          v-if="cloudTenantLeaders.shares[2] === entity.id"
          class="h-5"
          src="/img/cloud_badges/badge_shares_bronze.png"
          alt="CareerWise tenant category leader badge"
        />
      </div>

      <!-- Tenant leader description -->
      <div
        v-if="
          cloudTenantLeaders.flagged_tenants.includes(entity.id) &&
          entity.type === 2
        "
        :style="[{ left: '-20%' }, { width: '20rem' }]"
        class="z-50 absolute opacity-0 pointer-events-none group-hover:pointer-events-auto group-hover:opacity-100 bottom-0 bg-white rounded px-6 py-4 border border-truegray-300 text-black shadow"
      >
        <h3 class="mb-4 text-lg">
          CareerWise
          <span class="hotshot font-primary font-bold">Hotshot</span>
        </h3>
        <div class="flex flex-col space-y-4">
          <div
            v-if="cloudTenantLeaders.share_avg.includes(entity.id)"
            class="flex items-center"
          >
            <div class="h-8 pr-4 flex-shrink-0">
              <img
                v-if="cloudTenantLeaders.share_avg[0] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_avg_gold.png"
                alt="CareerWise tenant category leader badge"
              />
              <img
                v-if="cloudTenantLeaders.share_avg[1] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_avg_silver.png"
                alt="CareerWise tenant category leader badge"
              />
              <img
                v-if="cloudTenantLeaders.share_avg[2] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_avg_bronze.png"
                alt="CareerWise tenant category leader badge"
              />
            </div>
            <div class="flex flex-col">
              <h5 class="text-xs text-cw-alt uppercase">
                Average Shares Leader
              </h5>
              <h5 class="text-xs italic">
                This badge is awarded for being in the top 3 schools who have
                the highest average shares per post recently.
              </h5>
            </div>
          </div>

          <div
            v-if="cloudTenantLeaders.posts.includes(entity.id)"
            class="flex items-center"
          >
            <div class="h-8 pr-4 flex-shrink-0">
              <img
                v-if="cloudTenantLeaders.posts[0] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_posts_gold.png"
                alt="CareerWise tenant category leader badge"
              />
              <img
                v-if="cloudTenantLeaders.posts[1] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_posts_silver.png"
                alt="CareerWise tenant category leader badge"
              />
              <img
                v-if="cloudTenantLeaders.posts[2] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_posts_bronze.png"
                alt="CareerWise tenant category leader badge"
              />
            </div>
            <div class="flex flex-col">
              <h5 class="text-xs text-cw-alt uppercase">Post Leader</h5>
              <h5 class="text-xs italic">
                This badge is awarded for being in the top 3 schools who have
                contributed the most posts into the Cloud recently.
              </h5>
            </div>
          </div>

          <div
            v-if="cloudTenantLeaders.shares.includes(entity.id)"
            class="flex items-center"
          >
            <div class="h-8 pr-4 flex-shrink-0">
              <img
                v-if="cloudTenantLeaders.shares[0] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_shares_gold.png"
                alt="CareerWise tenant category leader badge"
              />
              <img
                v-if="cloudTenantLeaders.shares[1] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_shares_silver.png"
                alt="CareerWise tenant category leader badge"
              />
              <img
                v-if="cloudTenantLeaders.shares[2] === entity.id"
                class="h-8"
                src="/img/cloud_badges/badge_shares_bronze.png"
                alt="CareerWise tenant category leader badge"
              />
            </div>
            <div class="flex flex-col">
              <h5 class="text-xs text-cw-alt uppercase">Shares Leader</h5>
              <h5 class="text-xs italic">
                This badge is awarded for being in the top 3 schools whose cloud
                posts have been shared the most recently.
              </h5>
            </div>
          </div>
        </div>

        <h6 class="text-xs italic mt-4">
          click the logo to view the {{ entity.title }} cloud profile
        </h6>
        <button
          class="btn btn-cw-300 h-8 px-3 mt-4 m-0 text-xs"
          @click="showCloudStatModal"
        >
          View Cloud Stats
        </button>
      </div>
    </div>
    <a
      ref="viewProfile"
      :href="settings.cloud_domain + entity.directory_url"
      target="_blank"
      class="hidden"
    ></a>
    <div class="flex flex-col justify-center">
      <h6 v-if="context === 'posts'" class="text-truegray-300">Author</h6>
      <h6 v-if="context === 'connections'" class="text-truegray-300">
        Organisation
      </h6>
      <h6
        v-if="entity.title"
        :style="{ maxWidth: '180px' }"
        class="text-sm text-truegray-500 truncate overflow-ellipsis"
      >
        {{ entity.title }}
      </h6>
      <h6 v-if="entity.post_count" class="text-cw-alt">
        Posts: {{ entity.post_count }}
      </h6>

      <h6 v-if="publishedAt" class="text-truegray-400 mb-3">
        Published on {{ publishedAt }}
      </h6>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    entity: {
      type: Object,
      required: true,
    },

    publishedAt: {
      type: String,
      default: null,
    },

    context: {
      type: String,
      default: 'posts',
    },
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      cloudTenantLeaders: 'careerwise/getCloudTenantLeaders',
    }),
  },

  methods: {
    showProfile() {
      if (!this.context === 'connections') {
        this.$refs.viewProfile.click()
      }
    },

    showCloudStatModal() {
      EventBus.$emit('showModal', 'cloud-stats')
    },
  },
}
</script>

<style scoped>
.hotshot {
  background: -webkit-linear-gradient(45deg, var(--cw-700), var(--cw-alt));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
</style>
